export default __webpack_public_path__ + "static/media/c1.80685d2d.jpg";